module.exports = {"transport-service":"default","quoteandbind_lob":["pa","ho"],"agentquoteandbind":"false","phone-validation":["libphonenumber"]}


/*****************
 ** WEBPACK FOOTER
 ** ./common/grunt/webpack/loaders/effective-features!
 ** module id = 351
 ** module chunks = 0
 **/